import { SkeletonBlock } from '../../SkeletonBlock/SkeletonBlock';
import { SkeletonCard, SkeletonListRow, SkeletonStatChip } from '../common';

const ROWS_COUNT = 4;
const STATS_COUNT = 5;

const RIGHT_BLOCK = (
  <div className="flex items-center gap-2 shrink-0">
    {Array.from({ length: STATS_COUNT }).map((_, j) => (
      <SkeletonStatChip key={j} />
    ))}
  </div>
);

export function GroupCard() {
  return (
    <SkeletonCard className="h-[217px] gap-[16px]">
      <SkeletonBlock className="h-[12px] min-w-[133px] w-[30%] rounded-[24px]" variant="sunked" />
      <div className="flex flex-col gap-2">
        {Array.from({ length: ROWS_COUNT }).map((_, i) => (
          <SkeletonListRow key={i} rowClassName="gap-2" rightBlock={RIGHT_BLOCK} />
        ))}
      </div>
    </SkeletonCard>
  );
}
